import { Container, ModalConfirm } from '@bpba/ui-components';
import { CANJE_CONFIRMATION } from '../shared/Constantes';

export type InvitadosConfirmacionProps = {
  show: boolean;
  onClose: () => void;
  onAccept: () => void;
  onDecline: () => void;
};

export function InvitadosConfirmacion(props: InvitadosConfirmacionProps) {
  return (
    <ModalConfirm show={props.show} onConfirm={props.onAccept} onCancel={props.onDecline}>
      <Container maxWidth={[`calc(100vw - 20vw)`]} onClick={onClick}>
        <div dangerouslySetInnerHTML={{ __html: CANJE_CONFIRMATION }} />
      </Container>
    </ModalConfirm>
  );
}

function onClick(ev: React.MouseEvent<HTMLDivElement, MouseEvent>) {
  ev.stopPropagation();
}
